import React from 'react';
import { benefits as defaultBenefits } from '../engagementContent';

const BenefitsSection = ({
  items = defaultBenefits,
  eyebrow = 'What they deliver',
  title = 'A hire that pays for itself in repeat revenue',
}) => {
  return (
    <section className="py-14 md:py-20 bg-[#f7f8fa]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="mb-8 md:mb-10">
          <p className="text-[11px] sm:text-xs font-medium uppercase tracking-[0.18em] text-gray-400 mb-3">
            {eyebrow}
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-[2rem] font-semibold tracking-tight text-gray-900 leading-snug max-w-2xl">
            {title}
          </h2>
        </div>

        <div className="rounded-2xl border border-gray-200 bg-white overflow-hidden">
          <div className="grid sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-gray-100">
            {items.map((item) => (
              <div key={item.label} className="px-6 py-7 md:px-8 md:py-8">
                <p className="text-[11px] font-medium uppercase tracking-[0.16em] text-gray-400">
                  {item.label}
                </p>
                <p className="mt-3 text-3xl sm:text-[2rem] font-semibold tracking-tight text-gray-900 tabular-nums">
                  {item.metric}
                </p>
                <p className="mt-2 text-sm text-gray-500 leading-relaxed max-w-[18rem]">
                  {item.detail}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
